import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CrmdealskanbanComponent } from './crmdealskanban.component';

const routes: Routes = [{ path: '', component: CrmdealskanbanComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CrmdealskanbanRoutingModule { }
